import React from "react";
import RedHeartImg from "../../assets/redHeart.svg";
import SpecsBoyImg from "../../assets/headingImg1.svg";
import girlImg from "../../assets/HiveFiveGirl.svg";
import smallHeartImg from "../../assets/SmallRedHeart (2).svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const highFiveContent = [
  {
    title: "PHYSICAL",
    titleSubHeading: "DEVELOPMENT",
    bgColor: "#FFDDDD",
    textColor: "#d31c4f",
    content: [
      {
        heading: "Gross motor skills",
        subHeading: "(crawling, walking, running, jumping)",
      },
      {
        heading: "fine motor skills",
        subHeading: "(grasping objects, drawing, writing)",
      },
      {
        heading: "coordination and balance",
      },
      {
        heading: "sensory development",
        subHeading: "(vision, hearing, touch and feel smell)",
      },
    ],
  },
  {
    title: "CREATIVE",
    titleSubHeading: "DEVELOPMENT",
    bgColor: "#FFE7C4",
    textColor: "#d31c4f",
    content: [
      {
        heading: "imagination and creativity",
        subHeading: "(crawling, walking, running, jumping)",
      },
      {
        heading: "exploration of various art forms",
        subHeading: "(drawing, painting, music, dance)",
      },
      {
        heading: "role playing and pretend play",
      },
      {
        heading: "problem-solving through creative means",
      },
      {
        heading: "Appreciation of aesthetics",
      },
    ],
  },
  {
    title: "cognitive",
    titleSubHeading: "DEVELOPMENT",
    bgColor: "#E6EBFF",
    textColor: "#d31c4f",
    content: [
      {
        heading: "Attention and response",
      },
      {
        heading: "memory",
      },
      {
        heading: "thinking",
      },
      {
        heading: "following simple instructions",
      },
      {
        heading: "problem/puzzle - solving",
      },
      {
        heading: "simple reasoning",
      },
    ],
  },
  {
    title: "LANGUAGE",
    titleSubHeading: "DEVELOPMENT",
    bgColor: "#FEEFFF",
    textColor: "#d31c4f",
    content: [
      {
        heading: "Listening",
      },
      {
        heading: "Speaking",
      },
      {
        heading: "Reading",
      },
      {
        heading: "Non-Verbal Communications",
        subHeading: "(Gestures, Facial Expressionsl)",
      },
    ],
  },
  {
    title: "SOCIO EMOTIONAL",
    titleSubHeading: "DEVELOPMENT",
    bgColor: "#E7DCFF",
    textColor: "#D31C4F",
    content: [
      {
        heading: "Formation Of Relationships",
        subHeading: "(Parents,Siblings,Peers)",
      },
      {
        heading: "Interaction With Peer Group",
      },
      {
        heading: "Interaction With Adults Around",
      },
      {
        heading: "Social Skills",
        subHeading: "(Sharing, Taking Turns, Cooperation)",
      },
      {
        heading: "Learning To Maintain Personal Hygiene",
      },
    ],
  },
];
const HighFive = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: window.innerWidth < 450 ? 2000 : 3000,
    autoplaySpeed: window.innerWidth < 450 ? 2000 : 3000,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          cssEase: "linear",
        },
      }
      ,
      {
        breakpoint: 1514, // Below 900px
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 1,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 1440, // Below 900px
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 1,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 1200, // Below 900px
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 1900, // Below 900px
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 500, // Below 500px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 0.5,
          cssEase: "linear",
        },
      },
    ],
  };
  return (
    <div className="bg-white relative flex flex-col  px-[4%] py-[50px] pb-[100px]">
      <img
        src={RedHeartImg}
        alt="heart"
        className="absolute bottom-[3%] left-[20%]"
      />
      <img
        src={SpecsBoyImg}
        alt="childImage1"
        className="absolute lg:h-[110px] h-[100px] right-0 top-[10px] sm:top-[7%]"
      />
      <img
        src={girlImg}
        alt="childImage1"
        className="absolute left-0 lg:left-[4%] top-[190px] sm:top-[0%] lg:top-[0px] h-[150px] sm:h-[250px] lg:h-[300px]"
      />
      <div className="text-center z-10 mt-[50px]">
        <span className="text-[#d31c4f] text-[50px] font-bold font-Lato leading-[65px]">
          The{" "}
        </span>
        <span className="text-[#d31c4f] text-[34px] sm:text-[50px] font-normal font-Wonderbar leading-[65px]">
          High Fives{" "}
        </span>
        <span className="text-[#d31c4f] text-[50px] font-bold font-Lato leading-[65px]">
          of <br />
        </span>
        <span className="text-[#303030] text-[34px] sm:text-[50px] font-bold font-Lato leading-[40px] sm:leading-[65px]">
          a Child’s Holistic Development
        </span>
      </div>
      <div className="mt-[100px]  mb-[40px]">
        <Slider {...settings} className="sm:pl-0 pl-5 sm:px-5 pb-3 px-2">
          {highFiveContent?.map((item, row) => (
            <div>
              <div
                key={row}
                className={`min-w-[250px] max-w-[310px] pt-[50px] sm:min-w-[423px] sm:max-w-[450px] flex z-30 flex-col  gap-7 py-[5%] items-center h-[500px] rounded-lg`}
                style={{ background: item?.bgColor }}
              >
                <div className="flex flex-col gap-1">
                  <h1
                    style={{
                      color: item?.textColor ? item?.textColor : "black",
                    }}
                    className={`text-center text-[38px] font-normal font-Wonderbar leading-[53.20px] tracking-wider`}
                  >
                    {item?.title}
                  </h1>
                  <div className="text-center text-[#333333] text-[22px] font-bold font-Lato leading-relaxed tracking-[4.84px]">
                    DEVELOPMENT
                  </div>
                </div>
                <div className="self-center">
                  {item?.content?.map((items, index) => (
                    <div className="flex  flex-col mt-1">
                      <p className="text-center  text-[#101010] text-[17px] font-normal font-Lato capitalize leading-relaxed">
                        {items?.heading}
                      </p>
                      {items?.subHeading && (
                        <div>
                          <span className="text-[#101010] text-sm font-normal font-Lato capitalize leading-tight">
                            {items?.subHeading}
                          </span>
                        </div>
                      )}
                      {index !== item?.content?.length - 1 && (
                        <div className="flex self-center mt-[2px] flex-row gap-[3px]">
                          {[0, 1, 2]?.map((index) => (
                            <img
                              src={smallHeartImg}
                              alt="white Heart"
                              className=""
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HighFive;
